import React from 'react';
import cx from 'classnames';

interface Props {
  onClick: () => void;
  hasSeePhone: boolean;
  dataValue?: string;
}

export const RevealPhone = ({ onClick, hasSeePhone, dataValue }: Props) => {
  const dataValueWithType = dataValue ? `${dataValue}` : '';
  const seePhoneClass = cx('gtmShowStorePhone ml4 f14 fw6 abbey underline transition-ease link', {
    'o-0': hasSeePhone,
    'o-1 pointer': !hasSeePhone,
  });
  const handleKeyPress = (e: any) => {
    const keyCode = e.which || e.keyCode;
    const ENTER = 13;
    if (keyCode === ENTER && onClick) {
      onClick();
    }
  };
  return (
    <span
      tabIndex={0}
      className={seePhoneClass}
      onClick={onClick}
      title="Ver telefone"
      aria-label="Ver telefone"
      data-value={dataValueWithType}
      onKeyPress={handleKeyPress}
    >
      Ver telefone
    </span>
  );
};
